import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hidePhone'
})
export class HidePhonePipe implements PipeTransform {
  transform(phone: string): string {
    if (!phone) return '';

    const digits = phone.replace(/\D/g, '');

    if (digits.length < 7) return phone;

    const start = digits.slice(0, 4);
    const end = digits.slice(-2);
    const asterisks = '*'.repeat(digits.length - start.length - end.length);
    const maskedDigits = `${start}${asterisks}${end}`;

    let maskedIndex = 0;

    return phone.replace(/\d/g, () => maskedDigits[maskedIndex++] || '');
  }
}
